import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiChevronDown } from 'react-icons/fi'; // Using react-icons library
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { FaFileExcel } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FiChevronUp } from 'react-icons/fi';
import { User } from 'react-feather'; // Import the User icon



const Container = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 3px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
      color:#293495;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const Card = styled.div`
  box-shadow: 0px 5px 10px #00000038;
  background:#F5F5F5;
  border-radius: 10px;
  opacity: 1;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 200px;
`;

const Label = styled.label`
  color: #3D46B4;
  margin-bottom: 5px;
`;

const Dropdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #3D46B4;
  padding: 10px;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  position: relative;
  background:transparent;
`;

const DropdownText = styled.span`
  color: #293495;
  font-size: 16px;
`;

const DropdownIcon = styled(FiChevronDown)`
  color: #3D46B4;
`;

const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 5px); /* Positioning panel just below the dropdown */
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #3D46B4;
  border-radius: 4px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

const DropdownOption = styled.div`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 20px;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  &:first-child {
    background-color: #FF4B4B;
    box-shadow: 0px 10px 20px #7E18182E;
  }
  &:last-child {
    background-color: #2B3497;
    box-shadow: 0px 10px 20px #2B349752;
  }
`;


const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(to bottom, #E6E6E6, #F2F2F2, #F5F5F5, #F3F3F3, #E9E9E9);
  box-shadow: 0px 10px 20px #0000001A;
  border-radius: 6px;
  opacity: 1;
`;



const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
`;

const TableBody = styled.tbody``;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;
const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2b3497;
  margin: 0 5px;
`;
const StyledDropdown = styled.select`
  border: none;
  border-bottom: 2px solid #293495;
  padding: 5px;
  font-size: 16px;
  background: transparent;
  outline: none; /* Remove default focus outline */
`;
const PassReturnInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;
const CustomInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const EmployeeNameInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const EmployeeNameInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const LocationInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: 20px;
`;

const LocationInput = styled.input`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const CompanyInputContainer = styled.div`
display: flex;
flex-direction: column;
gap: 5px;
margin-left: 20px;
`;

const CompanyInput = styled.input`
width: 200px;
padding: 8px 0;
border: none;
border-bottom: 1px solid #2B3497;
font-family: 'Segoe UI', Regular;
background: transparent;
&:focus {
  outline: none;
  border-bottom: 2px solid #2B3497;
}
`;
const StyledDatePicker = styled(DatePicker)`
  width: 200px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2B3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2B3497;
    }
  }`

const DateInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

`;
const DateContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-left: 20px;

`;
const ExportIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  color: #28a745; /* Green color for Excel icon */
`;

const DropdownContainerTwo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;


  // &:hover {
  //   color: #293495;
  // }
`;

// Styling for the custom options panel
const OptionsPanel = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

// Individual option items
const OptionItem = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // margin:14px 44px;
`;
const ProfileIcon = styled.div`
 width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;


const GroupReports = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const dropdownRef = useRef(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [companyName, setCompanyName] = useState('');
  const [host, setHostName] = useState('');
  const [locationName, setLocationName] = useState('');
  const [passReturn, setPassReturn] = useState('');
  const [visitorReports, setVisitorReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalItems, setTotalItems] = useState(0); // Define totalItems in the state

  const itemsPerPage = 10; // Number of items per page
  const [tableData, setTableData] = useState([]); // Initialize without dummy data
  const [searchQuery, setSearchQuery] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;
  const [locations, setLocations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  // Sort function
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  };

  const [formValues, setFormValues] = useState({
    host: '',
    locationName: ''

  }

  );



  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const [entity, setEntity] = useState([]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const locationsResponse = await axios.get('/Location');
        setLocations(locationsResponse.data);

        const employeesResponse = await axios.get('/employee');
        setEmployees(employeesResponse.data);

      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };
    const fetchDropdownDataEntity = async () => {
      try {

        const employeesResponse = await axios.get('/Entity/GetEntity');
        setEntity(employeesResponse.data);

      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };
    fetchDropdownDataEntity();

    fetchDropdownData();
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchVisitorTypeData = async () => {
    try {
      const response = await axios.get('/GroupAppointment/GetGroupAppointmentReports');
      setTableData(response.data);
      setOriginalTableData(response.data);

    } catch (error) {
      console.error('Error fetching Visitor Report data:', error);
    }
  };

  useEffect(() => {
    fetchVisitorTypeData();
  }, []);
  const [originalTableData, setOriginalTableData] = useState([]);


  const handleSearchData = () => {
    let filtered = [...originalTableData]; // Start with all data

    switch (selectedOption) {
      case 'Date Wise':
        if (fromDate && toDate) {
          const from = new Date(fromDate);
          from.setHours(0, 0, 0, 0); // Normalize fromDate to start of the day

          const to = new Date(toDate);
          to.setHours(23, 59, 59, 999); // Normalize toDate to end of the day

          filtered = filtered.filter(row => {
            const checkInDate = new Date(row.appointmentDate);
            checkInDate.setHours(0, 0, 0, 0); // Normalize appointmentDate to start of the day
            return checkInDate >= from && checkInDate <= to;
          });
        }
        break;
      case 'Company Wise':
        if (companyName) {
          filtered = filtered.filter(row =>
            row.visitorCompany && row.visitorCompany.toLowerCase().includes(companyName.toLowerCase())
          );
        }
        break;
      case 'Host Name Wise':
        if (formValues.host) {
          filtered = filtered.filter(row =>
            row.host && row.host.toLowerCase().includes(formValues.host.toLowerCase())
          );
        }
        break;
      case 'Location Wise':
        if (formValues.locationName) {
          filtered = filtered.filter(row =>
            row.meetingVenue && row.meetingVenue.toLowerCase().includes(formValues.locationName.toLowerCase())
          );
        }
        break;
      case 'Entity Wise':
        if (formValues.entityName) {
          filtered = filtered.filter(row =>
            row.entity && row.entity.toLowerCase().includes(formValues.entityName.toLowerCase())
          );
        }
        break;
      default:
        break;
    }

    setTableData(filtered);
    console.log('Filtering with host:', formValues.host);
    console.log('Filtered data:', filtered);

  };

  const filteredData = tableData.filter((row) =>
    row.id?.toString().includes(searchQuery) ||
    row.entity && row.entity.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.visitorName && row.visitorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.nationality && row.nationality.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.visitorCompany && row.visitorCompany.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.host && row.host.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.meetingVenue && row.meetingVenue.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.visitorMobile && row.visitorMobile.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);


  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const formatDateTime = (dateTime) => {
    return dateTime.replace('T', ' ');
  };
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  // Function to toggle the export options panel
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const handleExportOptionClick = (format) => {
    if (format === 'excel') {
      exportToExcel(); // Call the Excel export function
    } else if (format === 'pdf') {
      exportToPDF(); // Call the PDF export function
    }

    // Close the panel after making a selection
    setIsPanelOpen(false);
  };
  const formatDateTimeForExcel = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} : ${hours}:${minutes}:${seconds}`;
  };
  const exportToExcel = () => {
    const filteredDataNee = filteredData.map((row) => ({
      EntityName: row.entity,
      VisitorName: row.visitorName,
      VisitorId: row.id,
      VisitorMobile: row.visitorMobile,
      nationality: row.nationality,
      VisitorCompany: row.visitorCompany,
      HostName: row.host,
      LocationName: row.meetingVenue,
      AppointmentDateTime: formatDateTimeForExcel(row.appointmentDate),
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataNee);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Group Reports');

    // Adjust column widths for better alignment
    worksheet['!cols'] = [
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Name
      { wpx: 150 }, // Visitor Mobile
      { wpx: 150 }, // Visitor Mobile
      { wpx: 200 }, // Visitor Company
      { wpx: 150 }, // Employee Name
      { wpx: 150 }, // Location Name
      { wpx: 200 }, // Check-In Date Time
    ];

    XLSX.writeFile(workbook, 'Group__Report.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text('Group  Report', 14, 16);
    doc.autoTable({
      head: [
        ['Photo', 'Entity Name', 'Visitor Name', 'Visitor Id', 'Visitor Mobile', 'Nationality', 'Visitor Company', 'Host Name', 'Location Name', 'Appointment Date Time']
      ],
      body: filteredData.map((row) => [
        '',
        row, entity,
        row.visitorName,
        row.id,
        row.visitorMobile,
        row.nationality,
        row.visitorCompany,
        row.host,
        row.meetingVenue,
        formatDateTimeForExcel(row.appointmentDate),
      ]),
      startY: 30,
      theme: 'grid',
      theme: 'grid', didDrawCell: (data) => {
        // Ensure we only process body cells, not header or footers
        if (
          data.section === 'body' &&
          data.column.index === 0 &&
          filteredData[data.row.index]?.visitorPhoto
        ) {
          try {
            // Clean base64 string if it already includes the data URI prefix
            let base64 = filteredData[data.row.index].visitorPhoto;
            base64 = base64.replace(/^data:image\/(png|jpeg);base64,/, '');

            const img = `data:image/png;base64,${base64}`;

            const cellWidth = data.cell.width;
            const cellHeight = data.cell.height;
            const imgSize = Math.min(cellWidth, cellHeight) - 2;
            const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
            const yOffset = data.cell.y + (cellHeight - imgSize) / 2;

            doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
          } catch (err) {
            console.error('Error adding image:', err);
          }
        }
      },
    });
    doc.save('Group_Report.pdf');
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };


  return (
    <Container>
      <Header>
        <Heading>Group Report</Heading>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SearchBox>
            <SearchIcon size={20} />
            <SearchInput
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </SearchBox>
          <DropdownContainerTwo>
            <ExportIcon onClick={togglePanel} title="Export">
              <FiDownload size={25} />
            </ExportIcon>
            {/* Show the panel with options if isPanelOpen is true */}
            {isPanelOpen && (
              <OptionsPanel>
                <OptionItem onClick={() => handleExportOptionClick('excel')}>Excel</OptionItem>
                <OptionItem onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItem>
              </OptionsPanel>
            )}
          </DropdownContainerTwo>
        </div>
      </Header>

      <Card>
        <DropdownContainer ref={dropdownRef}>
          <Label>Report Type</Label>
          <Dropdown onClick={toggleDropdown}>
            <DropdownText>{selectedOption || 'Select Type'}</DropdownText>
            <DropdownIcon size={20} />
          </Dropdown>
          {isOpen && (
            <DropdownPanel>
              {['Date Wise', 'Company Wise', 'Host Name Wise', 'Entity Wise', 'Location Wise'].map((option) => (
                <DropdownOption key={option} onClick={() => handleOptionClick(option)}>
                  {option}
                </DropdownOption>
              ))}
            </DropdownPanel>
          )}
        </DropdownContainer>
        {selectedOption === 'Date Wise' && (
          <DateContainer>
            <DateInputContainer>
              <Label>From Date</Label>
              <StyledDatePicker
                selected={fromDate}
                onChange={(date) => setFromDate(date)}
                dateFormat="dd-MM-yyyy"
                maxDate={new Date()} // Prevent selecting future dates

              />
            </DateInputContainer>
            <DateInputContainer>
              <Label>To Date</Label>
              <StyledDatePicker
                selected={toDate}
                onChange={(date) => setToDate(date)}
                dateFormat="dd-MM-yyyy"
                minDate={fromDate}
                maxDate={new Date()} // Prevent selecting future dates


              />
            </DateInputContainer>
          </DateContainer>
        )}
        {selectedOption === 'Company Wise' && (
          <CompanyInputContainer>
            <Label>Company Name</Label>
            <CompanyInput
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Enter company name"
            />
          </CompanyInputContainer>
        )}
        {selectedOption === 'Host Name Wise' && (
          <EmployeeNameInputContainer>
            <Label>Hosts Name</Label>
            <StyledDropdown
              name="host"
              value={formValues.host}
              onChange={handleInputChange}
            >
              <option value="">Select host Name</option>
              {employees.map((employee) => (
                <option key={employee.id} value={employee.employeeName}>
                  {employee.employeeName}
                </option>
              ))}
            </StyledDropdown>
          </EmployeeNameInputContainer>
        )}
        {selectedOption === 'Entity Wise' && (
          <EmployeeNameInputContainer>
            <Label>Entity</Label>
            <StyledDropdown
              name="entityName"
              value={formValues.entityName}
              onChange={handleInputChange}
            >
              <option value="">Select Entity Name</option>
              {entity.map((employee) => (
                <option key={employee.id} value={employee.entityName}>
                  {employee.entityName}
                </option>
              ))}
            </StyledDropdown>
          </EmployeeNameInputContainer>
        )}
        {selectedOption === 'Location Wise' && (
          <LocationInputContainer>
            <Label>Location Name</Label>
            <StyledDropdown
              name="locationName"
              value={formValues.locationName}
              onChange={handleInputChange}
            >
              <option value="">Select Location</option>
              {locations.map((location) => (
                <option key={location.id} value={location.locationName}>
                  {location.locationName}
                </option>
              ))}
            </StyledDropdown>
          </LocationInputContainer>
        )}

        <ButtonGroup>

          <Button onClick={() => {
            setFromDate(null);
            setToDate(null);
            setCompanyName('');
            setFormValues({
              host: '',
              locationName: ''
            });
            setPassReturn('');
            setSelectedOption('');
            setTableData([]);
            setTableData([...originalTableData]);
            fetchVisitorTypeData();
            setCurrentPage(1); // Reset pagination to the first page
            setSearchQuery('')
          }}>Reset</Button>
          <Button onClick={handleSearchData}>Search</Button>
        </ButtonGroup>
      </Card>
      {filteredData.length === 0 && (
        <ZeroStateMessage>No data found.</ZeroStateMessage>
      )}
      {filteredData.length > 0 && (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <TableHeader colSpan={'10'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Group  Report </span>
                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                      {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </IconWrapper>
                  </div>
                </TableHeader>

              </tr>
            </thead>
            {isExpanded && (
              <>
                <thead>
                  <tr>
                    <TableHeader>Photo</TableHeader>
                    <TableHeader onClick={() => handleSort('entity')}>Entity Name {sortColumn === 'entity' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name {sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('id')}>Visitor Id {sortColumn === 'visitoridName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorMobile')}>Visitor Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('nationality')}>Nationality {sortColumn === 'nationality' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorCompany')}>Visitor Company{sortColumn === 'visitorCompany' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('host')}>Host Name{sortColumn === 'host' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('meetingVenue')}>Location Name{sortColumn === 'meetingVenue' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('appointmentDate')}>Appointment Date Time{sortColumn === 'appointmentDate' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Circle> {row.visitorPhoto ? (
                          <img
                            src={`data:image/png;base64,${row.visitorPhoto}`}
                            alt="Profile"
                            style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                          />
                        ) : (
                          <ProfileIcon>
                            <User size={15} />
                          </ProfileIcon>
                        )}
                        </Circle>
                      </TableCell>
                      <TableCell>{row.entity}</TableCell>
                      <TableCell>{row.visitorName}</TableCell>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.visitorMobile}</TableCell>
                      <TableCell>{row.nationality}</TableCell>
                      <TableCell>{row.visitorCompany}</TableCell>
                      <TableCell>{row.host}</TableCell>
                      <TableCell>{row.meetingVenue}</TableCell>
                      <TableCell>
                        {new Intl.DateTimeFormat('en-CA', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                          hour12: false
                        }).format(new Date(row.appointmentDate))
                          .replace(',', ' :')}
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </>)}
          </StyledTable>
          {isExpanded && (
            <>
              <PaginationContainer>
                <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                  Previous
                </PaginationButton>

                <DropdownSelect value={currentPage} onChange={handlePageChange}>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </DropdownSelect>

                <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                  Next
                </PaginationButton>
              </PaginationContainer>
            </>)}
        </TableContainer>
      )}
    </Container>
  );
};
export default GroupReports;
